import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
//managers
import LocalStorageManager from "../constants/LocalStorageManger";
//constants
import { LocalStorageKeys } from "../constants/LocalStorageKeys";
// Importing translation files

import translationEN from "./locales/en/translation.json";
import translationAR from "./locales/ar/translation.json";
import translationFA from "./locales/fa/translation.json";

//Creating object with the variables of imported translation files
const resources = {
    en: {
        translation: translationEN,
    },
    ar: {
        translation: translationAR,
    },
    fa: {
        translation: translationFA,
    },
};

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
    name: "customLocalStorageDetector",

    lookup() {
        return LocalStorageManager.getItem(LocalStorageKeys.I18_NEXT_LNG);
    },
});

//i18N Initialization
i18n.use(languageDetector)
    .use(initReactI18next)
    .init({
        supportedLngs: ["fa", "en", "ar"],
        fallbackLng: "fa",
        debug: false,
        interpolation: { escapeValue: false },
        resources,
        detection: {
            order: ["customLocalStorageDetector", "navigator"],
            caches: [],
        },

        // react i18next special options (optional)
        // override if needed - omit if ok with defaults

        react: {
            bindI18n: "languageChanged",
            bindI18nStore: "",
            transEmptyNodeValue: "",
            transSupportBasicHtmlNodes: true,
            transKeepBasicHtmlNodesFor: ["br", "strong", "i"],
            useSuspense: false,
        },
    });

export default i18n;
